import { IdVerificationSummaryCard } from 'components/IdVerificationSummaryCard/IdVerificationSummaryCard';

export const CandidateIdVerification = ({ idvSummary, isLoading = false }) => {
  return <IdVerificationSummaryCard loading={isLoading} idvSummary={idvSummary} />;
};
